import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  recommended: {
    id: 't.recommended',
    defaultMessage: 'Recommended',
  },
  seeAll: {
    id: 't.seeAll',
    defaultMessage: 'See All',
  },
  browseGenresButton: {
    id: 't.browseGenresButton',
    defaultMessage: 'Browse Genres',
  },
  browseButton: {
    id: 't.browseButton',
    defaultMessage: 'Browse',
  },
  deleteThisStation: {
    id: 't.deleteThisStation',
    defaultMessage: 'delete this station.',
  },
  notWhatIWanted: {
    id: 't.notWhatIWanted',
    defaultMessage: "That's Not What I Wanted",
  },
  thumbedUpOn: {
    id: 't.thumbedUpOn',
    defaultMessage: 'First thumbed up on {date} on your {station}',
  },
  stillListeningTitle: {
    id: 't.stillListeningTitle',
    defaultMessage: 'Are You Still Listening?',
  },
  stillListeningBody: {
    id: 't.stillListeningBody',
    defaultMessage: 'We don’t want to play to an empty room.',
  },
  stillListeningCTA: {
    id: 't.stillListeningCTA',
    defaultMessage: "I'm Still Listening",
  },
  liveNow: {
    id: 't.liveNow',
    defaultMessage: 'Live Now',
  },
  live: {
    id: 't.live',
    defaultMessage: 'LIVE',
  },
  closeStationNarrative: {
    id: 't.closeStationNarrative',
    defaultMessage: 'Close Station Description and Show Recent Stations',
  },
} as const);

export const NowPlayingKeys = Object.freeze({
  IS_SESSION_HISTORY_OPEN_KEY: 'isSessionHistoryOpen',
  IS_NOW_PLAYING_OPEN_KEY: 'isNowPlayingOpen',
  SESSION_HISTORY_INDEX_KEY: 'sessionHistoryIndex',
  IS_TPR_TEXT_FADED: 'isTprTextFaded',
  IS_UPDATING_FEEDBACK_KEY: 'isUpdatingFeedback',
  IS_MARKING_TRACK_AS_TIRED: 'isMarkingTrackAsTired',
  IS_NEXT_TRACK_LOADING: 'isNextTrackLoading',
} as const);
